var BaseViews = require('../../base');
var SubCategoryView = BaseViews.ItemView.extend({
    template: require('./sub-category/sub-category.html'),
    className: 'fmcy-sub-category-item',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
            }
        );
    },
    events: {
        'click': 'onClick'
    },
    onClick: function() {
        this.trigger('subcat:clicked');
    },
    serializeData: function () {
      return {
          category: this.model.toJSON()
      };
    },
    onRender: function () {
      this.$el.css('padding-left', this.model.get('level') * 10 + 'px');
    }
});

module.exports = SubCategoryView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/category-text-menu/sub-category.js
 **/